import React from 'react';
import { ST_NOTIFY_ABOUT } from '../../growth-settings/mockData';
import type { StToggleItem } from '../../growth-settings/types';
import { StDisplayHeading, StSectionCard, StToggleRow, type StSectionSaveFooter } from './SettingsPrimitives';

export interface SettingsNotificationsProps {
  toggles?: StToggleItem[];
  onToggleChange?: (key: string, enabled: boolean) => void;
  saveFooter?: StSectionSaveFooter;
}

export function SettingsNotifications({
  toggles = ST_NOTIFY_ABOUT,
  onToggleChange,
  saveFooter,
}: SettingsNotificationsProps) {
  return (
    <StSectionCard
      title="Notifications"
      description="Choose what ELVA tells you about and how."
      {...(saveFooter ? { saveFooter } : {})}
    >
      <section>
        <StDisplayHeading title="What to notify about" />
        <div className="mt-3">
          {toggles.map((rule) => (
            <StToggleRow
              key={rule.key ?? rule.label}
              label={rule.label}
              description={rule.description}
              enabled={rule.enabled}
              {...(rule.key && onToggleChange
                ? { onEnabledChange: (next: boolean) => onToggleChange(rule.key!, next) }
                : {})}
            />
          ))}
        </div>
      </section>
    </StSectionCard>
  );
}
